var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"comp-main"},_vm._l((_vm.formColumn),function(item,index){return _c('div',{key:index,staticClass:"form-item"},[_c('e-form',{attrs:{"column":item,"data":_vm.formData,"disabled":_vm.disabled},on:{"update:data":function($event){_vm.formData=$event}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }